import React from 'react';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';
import PropTypes from 'prop-types';

const Option = ({ innerRef, isDisabled, isFocused, isSelected, innerProps, children }) => (
  <div
    ref={innerRef}
    className={`px-4 py-2 cursor-pointer transition-colors ${
      isSelected ? 'font-medium bg-[#5882C1] text-white' : 
      isFocused ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
    } ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    {...innerProps}
  >
    {children}
  </div>
);

Option.propTypes = {
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  innerProps: PropTypes.object,
  children: PropTypes.node,
};

const LoadingMessage = ({ getStyles, ...props }) => (
  <div {...props} className="p-2 text-gray-500 text-center">
    <FormattedMessage id="loading" />
  </div>
);

LoadingMessage.propTypes = {
  getStyles: PropTypes.func.isRequired,
};

const components = {
  Option,
  LoadingMessage,
};

const InspectorsFilterComponent = ({ suggestions, isBusy, searchPlaceholder, handleChange }) => (
  <div className="font-['Open_Sans'] bg-white rounded shadow-sm border border-gray-300">
    <Select
      options={suggestions.map(suggestion => ({
        value: suggestion.public_id,
        label: suggestion.name,
      }))}
      isOptionDisabled={option => option.disabled}
      components={components}
      name="inspector"
      onChange={handleChange}
      placeholder={searchPlaceholder}
      isLoading={isBusy}
      backspaceRemovesValue={false}
      autoFocus
      styles={{
        control: (base) => ({
          ...base,
          border: 'none',
          boxShadow: 'none',
          minHeight: '38px',
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          background: 'transparent !important',
          border: 'none !important',
          boxShadow: 'none !important',
          '& input': {
            height: '100% !important',
            background: 'transparent !important',
            border: 'none !important',
            boxShadow: 'none !important',
            padding: '0 !important',
            margin: '0 !important',
          },
        }),
        menu: (base) => ({
          ...base,
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
          borderRadius: '4px',
          marginTop: '4px',
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: '200px',
          padding: 0,
        }),
      }}
    />
  </div>
);

InspectorsFilterComponent.propTypes = {
  suggestions: PropTypes.array.isRequired,
  isBusy: PropTypes.bool.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default InspectorsFilterComponent;
